<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="keyboardOrigin()"
  [cdkConnectedOverlayOpen]="show()"
  [cdkConnectedOverlayPositions]="keyboardPositions"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayFlexibleDimensions]="false"
  [cdkConnectedOverlayViewportMargin]="8"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  (detach)="saveVirtualKeyboard(false)"
>
  <div
    class="virtual-keyboard"
    [class.virtual-keyboard--numeric]="keyboardMode() === 'numeric'"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    role="group"
    aria-label="Virtual keyboard"
    #keyboardRef
  >
    <div class="drag-handle" cdkDragHandle>
      <cue-icon [icon]="ICONS.cueMove" /> {{ translation.navigation.drag | transloco }}
    </div>
    @for (row of keyboardRows(); track $index; let rowIndex = $index) {
      <div class="keyboard-row">
        @if (keyboardMode() === 'default' && rowIndex === 1) {
          <button type="button" class="key hidden" tabindex="-1" aria-hidden="true"></button>
        }
        @for (key of row; track key) {
          <ng-container [ngTemplateOutletContext]="{ button: key }" [ngTemplateOutlet]="keyboardKey" />
        }
      </div>
    }

    <ng-template #keyboardKey let-button="button">
      <button
        type="button"
        (mousedown)="handleKeyPress(button, $event)"
        (keydown.enter)="handleKeyPress(button, $event)"
        (keydown.space)="handleKeyPress(button, $event)"
        class="key"
        [class]="button.class"
        [attr.aria-label]="getKeyAriaLabel(button)"
        [ngClass]="{
          active: (isShiftActive && button.isShiftFn) || (isCtrlActive && button.isCtrlFn),
          'shift-active': isShiftActive && button.class === 'special-chars',
        }"
        [disabled]="isCtrlActive && button.isShiftFn"
      >
        @if (isSpecialKeys(button) || button.isSpaceFn) {
          @if (button.isDeleteFn) {
            <cue-icon [icon]="ICONS.cueDeleteBackspace" />
          }
          @if (button.isShiftFn) {
            Shift
          }
          @if (button.isCapsLockFn) {
            Caps Lock
          }
          @if (button.isSpaceFn) {
            <cue-icon [icon]="ICONS.cueSpacebar" />
          }
          @if (button.isCtrlFn) {
            <cue-icon [icon]="ICONS.cueSpecialChars" />
          }
          @if (button.isEnterFn) {
            <cue-icon [icon]="ICONS.cueEnter" />
          }
          @if (button.isCloseFn) {
            <cue-icon [icon]="ICONS.cueClose" />
          }
        } @else {
          @if (isShiftActive || isCapsLockActive) {
            {{ button.shiftValue || button.defaultValue.toUpperCase() }}
          }
          @if (isCtrlActive && !isShiftActive) {
            {{ button.ctrlValue }}
          }
          @if (!isShiftActive && !isCtrlActive && !isCapsLockActive) {
            {{ button.defaultValue }}
          }
        }
      </button>
    </ng-template>
  </div>
</ng-template>
